/** Review presence is always on (staging-first rollout; no client feature flag). */
export function isReviewPresenceEnabled(): boolean {
    return true;
}
